var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import styled from "../themes/styled";
import { themeGet } from "@styled-system/theme-get";
function getColor(p) {
    if (p.color) {
        return p.color.indexOf("#") !== -1 ? p.color : themeGet("colors.".concat(p.color))(p);
    }
    else {
        return "black";
    }
}
var Svg = styled.svg(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    path {\n        stroke: ", ";\n        fill: ", ";\n    }\n"], ["\n    path {\n        stroke: ", ";\n        fill: ", ";\n    }\n"])), getColor, function (p) { return (p.active ? getColor(p) : "transparent"); });
var IndexIcon = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 32 : _b, _c = _a.active, active = _c === void 0 ? false : _c, _d = _a.color, color = _d === void 0 ? "#585858" : _d, rest = __rest(_a, ["width", "active", "color"]);
    return (React.createElement(Svg, __assign({ width: width, viewBox: "0 0 53 31", xmlSpace: "preserve", active: active, color: color }, rest),
        React.createElement("path", { strokeWidth: "1", d: "M46.7,1L17.5,1c-1.9,0-3.1,1.3-3.4,2L1.8,23c-1.2,2-1.9,7,4.1,7l29.2,0c0.8,0,2.4-0.3,3.5-2 L51.3,7.2C52.5,5.2,52.8,1,46.7,1z" })));
};
export default IndexIcon;
var templateObject_1;
//# sourceMappingURL=IndexIcon.js.map